import React, { useEffect }  from 'react';
import { Card, CardContent, Container, Typography } from '@mui/material'
import { grey, yellow  } from '@mui/material/colors'
import { useRecoilState, useResetRecoilState, useSetRecoilState } from 'recoil';
import { activeStepRegisterState, resendCodeConfirmationState,  completedStepRegisterState, errorsFormRegisterState, rulesPasswordState, valuesFormRegisterState } from 'src/Patient/state/atoms';
import IndexCompleteInformation from 'src/Patient/register/IndexCompleteInformation';
import IndexConfirmAccount from 'src/Patient/register/IndexConfirmAccount';
import IndexCreatePassword from 'src/Patient/register/IndexCreatePassword';
import { showBannerState, resendCodeConfirmation } from 'src/store/global/bannerShowState';
import { stepperRegisterShowState } from 'src/store/global/steppersShowState';
import AlertCustom from 'src/shared/components/alerts/AlertCustom';
import { Link } from 'react-router-dom';
import { useTheme } from '@emotion/react';
import useSEO from 'src/Hooks/useSEO';

const Register = () => {
    const theme = useTheme();
    const [activeStepRegister, setActiveStepRegister] = useRecoilState(activeStepRegisterState);
    const resetPatientInformation = useResetRecoilState(valuesFormRegisterState);
    const resetPatientErrors = useResetRecoilState(errorsFormRegisterState);
    const resetRulesPassword = useResetRecoilState(rulesPasswordState);
    const resetActiveStepRegister = useResetRecoilState(activeStepRegisterState);
    const resetCompletedStepRegister = useResetRecoilState(completedStepRegisterState);
    const setShowBanner = useSetRecoilState(showBannerState);
    const setStepperRegisterShow = useSetRecoilState(stepperRegisterShowState);
    
    const [resendCodeConfirmation, setResendCodeConfirmation] = useRecoilState(resendCodeConfirmationState);

    useSEO({title: 'Crear cuenta'});

    useEffect(() => {
        setShowBanner(false);
        setStepperRegisterShow(true)
        
        return () => {
            setShowBanner(true);
            setStepperRegisterShow(false)
            resetPatientInformation();
            resetPatientErrors();
            resetRulesPassword();
            setActiveStepRegister(0);
            resetActiveStepRegister();
            resetCompletedStepRegister();
            setResendCodeConfirmation(false);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // useEffect(() => {
    //     console.log("resendCodeConfirmation => ", resendCodeConfirmation);
    //     if(resendCodeConfirmation === true){
    //         console.log("🔥TRUE🔥");
    //         const body = document.querySelector('.MuiPaper-root');

    //         body.scrollIntoView({
    //             behavior: 'smooth'
    //         }, 500)  

    //     }

    // }, [resendCodeConfirmation])

    return (
        <Container style={{ maxWidth: 703 }}>

            {
                resendCodeConfirmation === true ? (
                    <AlertCustom
                        severity="warning"
                        style={{ backgroundColor: yellow[100] , marginTop: '16px', }}
                        variant="outlined"
                        children={
                            <>
                                <p>Aún no ha confirmado su cuenta</p>
                                <p>Presione <Link style={{ color: theme.palette.primary.main, fontWeight: 'bold' }} to={`${process.env.REACT_APP_ROOT_SERVER_PATH}/resend-code`}>aquí</Link> para obtener nuevamente un codigo de confirmacion</p>
                            </>}
                    />
                ) : null
            }

            <Typography color={grey[700]} fontWeight={700} fontSize={24} pt={2}>
                CREE UNA NUEVA CUENTA
            </Typography>
            <Typography color={grey[400]} fontWeight={700} fontSize={12} pb={2}>
                INGRESE SUS DATOS
            </Typography>

            <Card>
                <CardContent>
                    {activeStepRegister === 0 && <IndexCompleteInformation />}
                    {activeStepRegister === 1 && <IndexCreatePassword />}
                    {activeStepRegister === 2 && <IndexConfirmAccount />}
                </CardContent>
            </Card>
        </Container>
    )
}

export default Register
